var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center"}},[_c('v-chart',{attrs:{"options":_vm.options,"theme":_vm.tema}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }